<template>
  <div>
    <SwitchCm :class="$style.switch" />
    <div v-if="!this.isCm">
      <label>Height (in):</label>
      <input
        :class="$style.input"
        type="text"
        :value="canvasInput.input1"
        placeholder="i.e. 64"
        @input="setCanvasInput({ ...canvasInput, input1: $event.target.value })"
      >
    </div>
    <div v-if="this.isCm">
      <label>Height (cm):</label>
      <input
        :class="$style.input"
        type="text"
        :value="canvasInput.input1"
        placeholder="i.e. 162"
        @input="setCanvasInput({ ...canvasInput, input1: $event.target.value })"
      >
    </div>
    <div v-if="!this.isCm">
      <label>Weight(lb):</label>
       <input
        :class="$style.input"
        type="text"
        :value="canvasInput.input2"
        @input="setCanvasInput({ ...canvasInput, input2: $event.target.value })"
      >
    </div>
    <div v-if="this.isCm">
      <label>Weight(kg):</label>
       <input
        :class="$style.input"
        type="text"
        :value="canvasInput.input2"
        @input="setCanvasInput({ ...canvasInput, input2: $event.target.value })"
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import SwitchCm from '@/components/lib/SwitchCm'

export default {
  components: { SwitchCm },
  computed: {
    ...mapState(['canvasInput', 'isCm'])
  },
  methods: {
    ...mapMutations(['setCanvasInput']),
  },
  mounted() {
    this.$emit('title', 'Enter Height and Weight')
    this.$emit('prevLink', 'MobileCanvas2')
    this.$emit('nextLink', 'MobileCanvasOutput')
  }
}
</script>

<style lang="scss" module>
.input {
  display: block;
  width: 100%;
  padding: 10px;
  margin: 10px;
}

.switch {
  margin-bottom: 20px;
}
</style>